<app-navbar></app-navbar>

<section class="py-20 md:py-24 xl:py-32 min-h-[50dvh] bg-white text-black">
    <div class="container mx-auto px-4">
        <h1 class="text-2xl">{{texts.title}}</h1>
        <div>
            <p class="py-3">{{texts.introduction}}</p>
            <p class="py-3">{{texts.types_of_cookies}}</p>
            <p class="py-3">{{texts.technical_cookies}}</p>
            <p class="py-3">{{texts.analytics_cookies}}</p>
            <p class="py-3">{{texts.advertising_cookies}}</p>
            <p class="py-3">{{texts.cookie_management}}</p>
            <p class="py-3">{{texts.consent}}</p>
            <p class="py-3">{{texts.contact}}</p>
            <p class="py-3">{{texts.updates}}</p>
        
        </div>
    </div>
</section>


<app-footer></app-footer>